/*
 * Created by jmeo at 2021-05-10
 * FileName: AsyncImg.tsx
 */
import React from "react";
import {show} from "./ImageModal";


type AsyncImgProps = any & {
    style?: any,
    src?: any,
    showsrc?: any,
    defaultSrc?: any,
    contain?: boolean,
    disabled?: boolean
}

class AsyncImg extends React.Component<AsyncImgProps, any> {

    destroy = false

    constructor(props: AsyncImgProps) {
        super(props);
        this.state = {
            imgSrc: props.defaultSrc,
            style: {}
        }
    }

    componentWillReceiveProps(nextProps: AsyncImgProps) {
        this.getImg(nextProps)
    }

    getImg(props: AsyncImgProps) {
        // const props = this.props;
        let src = props.src
        const defaultSrc = props.defaultSrc
        src = props.src || defaultSrc
        if (src) {
            new Promise((resolve, reject) => {
                const _img = new Image()
                _img.onerror = function (e) {
                    if (defaultSrc) {
                        console.log('load err src ', src)
                        resolve({src: defaultSrc})
                        return
                    }
                    reject(e)
                }
                _img.onload = function () {
                    const res: any = {src}
                    if (props.contain) {
                        const width = _img.width
                        const height = _img.height
                        const proportion = width / height
                        res.style = proportion > 1 ? {width: '100%'} : {height: '100%'}
                    }

                    resolve(res)
                }
                _img.src = src
            }).then((img: any) => {
                if (this.destroy) return
                this.setState({
                    imgSrc: img.src,
                    style: img.style
                })
            }).catch(() => {
                console.log('load err src ', src)
            })
        } else {
            this.setState({
                imgSrc: null
            })
        }
    }

    componentDidMount() {
        this.getImg(this.props)
    }

    componentWillUnmount() {
        this.destroy = true
    }

    render() {
        const {imgSrc, style} = this.state
        if (!imgSrc) {
            return <div/>
        }
        let props: AsyncImgProps = this.props;
        props = {
            ...props,
            src: imgSrc
        }
        return <img {...props} style={style}
                    onClick={(e) => {
                        if (!props.disabled && props.src) {
                            e.stopPropagation()
                            show({src: props.showsrc || props.src})
                        }
                    }}/>
    }
}

export default AsyncImg
